import { isPlatformBrowser } from '@angular/common';
import { EventEmitter, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import {
  GuideStep,
  UserManualOptions,
  UserManualState,
} from '../Interfaces/interfaces';
const defaultOptions: UserManualOptions = {
  title: 'Quick Guide',
  closable: true,
  dismissOnBackdrop: true,
  showThumbnails: true,
};
@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    // const originalComplete = this.showComponentSubject.complete.bind(
    //   this.showComponentSubject
    // );
    // this.showComponentSubject.complete = () => {
    //   console.trace('⚠️ showComponentSubject completed!');
    //   originalComplete();
    // };
  }

  public showComponentSubject = new BehaviorSubject<boolean>(false);
  showComponent$ = this.showComponentSubject.asObservable();

  setItem(key: string, value: string): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(key, value);
    }
  }

  getItem(key: string): string | null {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(key);
    }
    return null;
  }
  // private actionSource = new Subject<void>(); // Can pass data if needed
  private walletFunctionEmitter = new EventEmitter<void>();
  // action$ = this.actionSource.asObservable();
  triggerWalletFunction() {
    this.walletFunctionEmitter.emit();
  }

  getTriggerWalletObservable() {
    return this.walletFunctionEmitter.asObservable();
  }
  private chatReadFunctionEmitter = new EventEmitter<void>();
  // action$ = this.actionSource.asObservable();
  triggerChatReadFunction() {
    this.chatReadFunctionEmitter.emit();
  }

  getTriggerChatReadObservable() {
    return this.chatReadFunctionEmitter.asObservable();
  }
  private triggerFirebase = new EventEmitter<boolean>(false);
  // action$ = this.actionSource.asObservable();
  triggerFirebaseFunction(show: boolean) {
    this.triggerFirebase.emit(show);
  }

  getTriggerFirebaseObservable() {
    return this.triggerFirebase.asObservable();
  }
  private chatUnReadCountFunctionEmitter = new EventEmitter<void>();
  // action$ = this.actionSource.asObservable();
  triggerChatUnReadCountFunction() {
    this.chatUnReadCountFunctionEmitter.emit();
  }

  getTriggerChatUnReadCountObservable() {
    return this.chatUnReadCountFunctionEmitter.asObservable();
  }
  private profileImageSubject = new BehaviorSubject<string>(
    'https://cmax-2.pages.dev/assets/icons/profileimage.png',
  );
  profileImage$ = this.profileImageSubject.asObservable();

  //   Funtion call service use
  private triggerLogoutSubject = new EventEmitter<void>();

  triggerLogoutFunction() {
    this.triggerLogoutSubject.emit();
  }

  getTriggerLogoutObservable() {
    return this.triggerLogoutSubject.asObservable();
  }

  toggleComponentVisibility(show: boolean) {
    // if (this.showComponentSubject.closed) {
    //   console.warn(
    //     'showComponentSubject is closed — recreating new BehaviorSubject'
    //   );
    //   this.showComponentSubject = new BehaviorSubject<boolean>(show);
    //   this.showComponent$ = this.showComponentSubject.asObservable();
    // } else {
    this.showComponentSubject.next(show);
    // }
  }

  setProfileImage(image: string) {
    this.profileImageSubject.next(image);
  }
  //   Funtion call service use
  private triggerGameScoreHistory = new EventEmitter<void>();

  triggerScoreHistory() {
    this.triggerGameScoreHistory.emit();
  }

  getTriggerScoreHistoryObservable() {
    return this.triggerGameScoreHistory.asObservable();
  }

  //   Funtion call service use redeem
  private triggerGameRedeemHistory = new EventEmitter<void>();

  triggerRedeemHistory() {
    this.triggerGameRedeemHistory.emit();
  }

  getTriggerRedeemHistoryObservable() {
    return this.triggerGameRedeemHistory.asObservable();
  }
  //   Funtion call service use Lottery Screen
  private triggerGetLotteryTicket = new EventEmitter<void>();

  triggerLotteryTicket() {
    this.triggerGetLotteryTicket.emit();
  }

  getTriggerLotteryTicketObservable() {
    return this.triggerGetLotteryTicket.asObservable();
  }
  //   Funtion call service use Lottery History
  private triggerGetLotteryHistoryTicket = new EventEmitter<void>();

  triggerLotteryHistoryTicket() {
    this.triggerGetLotteryHistoryTicket.emit();
  }

  getTriggerLotteryTickethistoryObservable() {
    return this.triggerGetLotteryHistoryTicket.asObservable();
  }
  //   Funtion call service use Offer
  private triggerGameOfferHistory = new EventEmitter<void>();

  triggerOfferHistory() {
    this.triggerGameOfferHistory.emit();
  }

  getTriggerOfferHistoryObservable() {
    return this.triggerGameOfferHistory.asObservable();
  }

  redirectToRoute() {
    const token = localStorage.getItem('token');
    if (token) {
      this.router.navigate(['/dashboard/home']);
    } else {
      this.router.navigate(['/']);
    }
  }

  //   Funtion call service use KYC Header

  private triggerKYCHeader = new EventEmitter<void>();

  triggerKYCHeaders() {
    this.triggerKYCHeader.emit();
  }

  getTriggerKYCHeaders() {
    return this.triggerKYCHeader.asObservable();
  }

  // gameNameInitials(gameId: number): any {
  //   let gameInitials: string;
  //   switch (gameId) {
  //     case 1:
  //       gameInitials = 'eg';
  //       break;
  //     case 3:
  //       gameInitials = 'gt';
  //       break;
  //     case 4:
  //       gameInitials = 'jw';
  //       break;
  //     case 5:
  //       gameInitials = 'up';
  //       break;
  //     case 6:
  //       gameInitials = 'vb';
  //       break;
  //     case 7:
  //       gameInitials = 'vs';
  //       break;
  //     case 2:
  //       gameInitials = 'gv';
  //       break;
  //     case 8:
  //       gameInitials = 'gr';
  //       break;
  //     case 9:
  //       gameInitials = 'mw';
  //       break;
  //     case 10:
  //       gameInitials = 'fk';
  //       break;
  //     case 11:
  //       gameInitials = 'os';
  //       break;
  //     case 12:
  //       gameInitials = 'yl';
  //       break;
  //     case 13:
  //       gameInitials = 'cm';
  //       break;
  //     default:
  //       gameInitials = 'non';
  //   }
  //   return gameInitials;
  // }

  // Lotttery Share Data

  // Define this mapping outside the function or as a private property
  private readonly gameMapping: { [key: string]: string } = {
    EGame: 'eg',
    GameVault: 'gv',
    GoldenTreasure: 'gt',
    Juwa: 'jw',
    Juwa2: 'jw2',
    UltraPanda: 'up',
    VBLink: 'vb',
    Vegas: 'vs',
    GameRoom: 'gr',
    MilkyWay: 'mw',
    FireKirin: 'fk',
    OrionStar: 'os',
    Yolo: 'yl',
    CashMachine: 'cm',
    BlueDragon: 'bd',
    RiverPay: 'rp',
    CashVault: 'cv',
    MrAll: 'ma',
    CashFrenzy: 'cf',
    Mafia: 'mf',
    VegasLuck: 'vl',
    Gem: 'gm',
    WinStar: 'ws',
    AceClub: 'ac',
    LuckyStar: 'ls',
  };

  removeLeadingZero(event: any) {
    const input = event.target;
    if (
      input.value &&
      input.value.length > 1 &&
      input.value.startsWith('0') &&
      input.value[1] !== '.'
    ) {
      input.value = input.value.replace(/^0+/, '');
      input.dispatchEvent(new Event('input'));
    }
  }
  gameNameInitials(gameName: string): string {
    // Returns the initial from the map, or 'non' if the name isn't found
    return this.gameMapping[gameName] || 'non';
  }
  private lotteryDataSubject = new BehaviorSubject<any>(null);
  lotteryData$ = this.lotteryDataSubject.asObservable();

  // Set data securely
  setLotteryData(data: any) {
    this.lotteryDataSubject.next(data);
  }

  // Clear data after use
  clearData() {
    this.lotteryDataSubject.next(null);
  }

  // service code for user manual

  private readonly state$ = new BehaviorSubject<UserManualState>({
    open: false,
    steps: [],
    startIndex: 0,
    options: defaultOptions,
  });

  open(
    steps: GuideStep[],
    startIndex = 0,
    options?: Partial<UserManualOptions>,
  ) {
    const merged: UserManualOptions = { ...defaultOptions, ...(options || {}) };
    this.state$.next({ open: true, steps, startIndex, options: merged });
  }

  close() {
    const v = this.state$.value;
    this.state$.next({ ...v, open: false });
  }

  stateChanges(): Observable<UserManualState> {
    return this.state$.asObservable();
  }

  // getter setter for KYC Values

  private _data: any;
  private _isUpdated = false;

  setData(data: any, isUpdated: boolean): void {
    this._data = data;
    this._isUpdated = isUpdated;
  }

  getData() {
    return {
      data: this._data,
      isUpdated: this._isUpdated,
    };
  }
}
